var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 7.5,
    stroke: "#F88922"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6535 24.9303L20.2042 23.5942C19.7784 24.0493 19.1724 24.3337 18.5001 24.3337C17.2114 24.3337 16.1667 23.289 16.1667 22.0003C16.1667 20.7117 17.2114 19.667 18.5001 19.667C19.1724 19.667 19.7783 19.9513 20.2041 20.4063L22.6535 19.0703C22.6077 18.8879 22.5834 18.6969 22.5834 18.5003C22.5834 17.2117 23.6281 16.167 24.9167 16.167C26.2054 16.167 27.2501 17.2117 27.2501 18.5003C27.2501 19.789 26.2054 20.8337 24.9167 20.8337C24.2444 20.8337 23.6385 20.5493 23.2127 20.0943L20.7633 21.4303C20.8091 21.6127 20.8334 21.8037 20.8334 22.0003C20.8334 22.197 20.8091 22.3879 20.7633 22.5703L23.2127 23.9064C23.6385 23.4514 24.2444 23.167 24.9167 23.167C26.2054 23.167 27.2501 24.2117 27.2501 25.5003C27.2501 26.789 26.2054 27.8337 24.9167 27.8337C23.6281 27.8337 22.5834 26.789 22.5834 25.5003C22.5834 25.3037 22.6077 25.1127 22.6535 24.9303ZM18.5001 23.167C19.1444 23.167 19.6667 22.6447 19.6667 22.0003C19.6667 21.356 19.1444 20.8337 18.5001 20.8337C17.8557 20.8337 17.3334 21.356 17.3334 22.0003C17.3334 22.6447 17.8557 23.167 18.5001 23.167ZM24.9167 19.667C25.5611 19.667 26.0834 19.1447 26.0834 18.5003C26.0834 17.856 25.5611 17.3337 24.9167 17.3337C24.2724 17.3337 23.7501 17.856 23.7501 18.5003C23.7501 19.1447 24.2724 19.667 24.9167 19.667ZM24.9167 26.667C25.5611 26.667 26.0834 26.1447 26.0834 25.5003C26.0834 24.856 25.5611 24.3337 24.9167 24.3337C24.2724 24.3337 23.7501 24.856 23.7501 25.5003C23.7501 26.1447 24.2724 26.667 24.9167 26.667Z",
    fill: "#F88922"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.051d9ae3555adb9de7b4736dc12fe2f6.svg";
export { ForwardRef as ReactComponent };